import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { AiOutlineBook, AiOutlineControl, AiOutlineDesktop, AiOutlineRight } from 'react-icons/ai'
import { NavLink, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { deviceInfoStore, themeStore, useRecoilState, useRecoilValue, useSetRecoilState } from '@/store'

import Modal from '../Modal'
import TempClass from '../TempClass'
const { deviceShowState } = deviceInfoStore

const menu = [
  {
    icon: <AiOutlineBook />,
    title: '我的课程',
    subitem: [
      {
        title: '个人中心',
        link: '/center',
        type: 0
      },
      {
        title: '我的课表',
        link: '/center/myTimeTable',
        type: 0
      },
      {
        title: '已上课程',
        link: '/center/finishClass',
        type: 0
      }
    ]
  },
  {
    icon: <AiOutlineControl />,
    title: '设备检测',
    subitem: [
      {
        title: '在线检测',
        link: 'ittest',
        type: 2
      }
    ]
  },
  {
    icon: <AiOutlineDesktop />,
    title: '临时课堂',
    subitem: [
      {
        title: '临时课堂',
        link: 'tempclass',
        type: 2
      }
    ]
  }
]

export default function Index() {
  const location = useLocation()
  const setDeviceShow = useSetRecoilState(deviceShowState)
  const [showTempClass, setShowTempClass] = useState<boolean>(false)

  const events = (link: string) => {
    console.log(link)
    switch (link) {
      case 'ittest':
        setDeviceShow(true)
        break
      case 'tempclass':
        setShowTempClass(true)
        break
    }
  }

  return (
    <Container className="w-[160px]">
      <ul className="m-0 p-0 list-none">
        {menu.map(({ icon, title, subitem }) => (
          <li className="group" key={title}>
            <div className="flex items-center justify-start text-[16px]">
              <div className="text-[#6a6a6a] w-[20px]">{icon}</div>
              <div className="ml-[5px] font-medium">{title}</div>
            </div>
            <ul className="m-0 p-0 list-none ml-[25px]">
              {subitem.map(({ title, link, type }) => (
                <li className={`subitem text-[14px] mt-[16px] mb-[16px] flex items-center justify-start ${location.pathname === link ? 'actives' : ''}`} key={title}>
                  {type === 0 ? (
                    <NavLink to={link} className="flex-1">
                      {title}
                    </NavLink>
                  ) : null}
                  {type === 1 ? (
                    <a className="flex-1" href={link}>
                      {title}
                    </a>
                  ) : null}
                  {type === 2 ? (
                    <span className="flex-1 cursor-pointer" onClick={() => events(link)}>
                      {title}
                    </span>
                  ) : null}
                  <AiOutlineRight />
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>

      <Modal show={showTempClass} footer="" header="" cancel={() => setShowTempClass(false)}>
        <TempClass
          cancel={() => {
            setShowTempClass(false)
          }}
        />
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  padding: 20px;
  background-color: #fff;
  border-radius: 6px;
  .group {
    position: relative;
    margin-bottom: 40px;
    ::before {
      content: '';
      position: absolute;
      bottom: -20px;
      width: 100%;
      height: 1px;
      background: #ededed;
    }
    :last-child {
      ::before {
        display: none;
      }
    }
    .subitem {
      transition: all 0.15s;
      :hover {
        color: #ff3300;
      }
    }
    .actives {
      color: #ff3300;
    }
  }
`
